export enum NewCartOrderStatus {
    UserStoreOrderCompletedStatus = 'UserStoreOrderCompletedStatus',
    UserStoreOrderPendingPaymentStatus = 'UserStoreOrderPendingPaymentStatus',
    UserStoreOrderExpiredStatus = 'UserStoreOrderExpiredStatus',
    UserStoreOrderCancelledStatus = 'UserStoreOrderCancelledStatus',
    UserStoreOrdersStatusCanceledByUser = 'UserStoreOrdersStatusCanceledByUser',
}

export enum NewCartOrderStatusValues{
    UserStoreOrderCompletedStatus = 50,
    UserStoreOrdersStatusCompleted = 50,
    UserStoreOrderPendingPaymentStatus = 40,
    PaymentRequestPending = 45,
    UserStoreOrderExpiredStatus = 10,
    UserStoreOrdersStatusCanceledByUser = 20,
    UserStoreOrderCancelledStatus = 60,
    UserStoreOrdersStatusCancelled = 60,
    StoreOrdersStatusConfirmed = 70,
    UserStoreOrdersStatusPlaced = 1,
    UserStoreOrdersStatusReverted = 30,
    UserStoreOrdersStatusPaymentVariantSet = 40,
}
